import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Tooltip from "@mui/material/Tooltip";
import DateRangeIcon from '@mui/icons-material/DateRange';

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

function MonthSelector(props) {
  function goToCurrentMonth() {
    const today = new Date();
    props.setCurrentMonth(today.getMonth());
    props.setCurrentYear(today.getFullYear());
  }

  // Function to check if we're on the current month
  function isCurrentMonth() {
    const today = new Date();
    return props.currentMonth === today.getMonth() && props.currentYear === today.getFullYear();
  }

  const isOnCurrentMonth = isCurrentMonth();

  return (
    <div className="relative">
      <div className="flex items-center text-center">
        <div
          className="w-9 h-9 rounded-l-lg border border-slate-200 text-slate-500 flex items-center justify-center hover:bg-slate-50 cursor-pointer"
          onClick={() => props.increment_month(-1)}
        >
          <ChevronLeftIcon />
        </div>
        <div
          className="w-9 h-9 rounded-r-lg border border-slate-200 text-slate-500 flex items-center justify-center hover:bg-slate-50 cursor-pointer"
          onClick={() => props.increment_month(1)}
        >
          <ChevronRightIcon />
        </div>
        <div
          className="ml-1 pl-4 pr-2.5 py-4 flex justify-center items-center rounded w-54 h-10 text-slate-900 hover:text-slate-900 bg-white cursor-default"
        >
          <div className="mr-1 lg:mr-0 xl:text-sm">
            {months[props.currentMonth]} {props.currentYear}
          </div>
        </div>
        <Tooltip title="Go to current month">
          <button
            className={`px-3 py-2 text-sm border border-slate-200 rounded-lg flex items-center gap-1 transition-colors ${
              isOnCurrentMonth
                ? "text-slate-400 bg-slate-50 cursor-not-allowed"
                : "text-slate-600 hover:text-violet-700 hover:bg-violet-50 cursor-pointer"
            }`}
            onClick={isOnCurrentMonth ? undefined : goToCurrentMonth}
            disabled={isOnCurrentMonth}
          >
            <DateRangeIcon style={{ fontSize: "16px" }} />
            <span className="hidden sm:inline">Today</span>
          </button>
        </Tooltip>
      </div>
    </div>
  );
}

export default MonthSelector;
